<template>
  <div class="alert" :class="alertClass" role="alert">
    <strong>{{ headline }}</strong><slot />

    <button
      v-if="dismissible"
      type="button"
      class="btn-close"
      data-bs-dismiss="alert"
      aria-label="Close"
    />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '', // success, alert, warning
    },
    headline: {
      type: String,
      default: null,
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    alertClass() {
      return [`alert-${this.type}`, (this.dismissible ? ' alert-dismissible fade show' : '')];
    },
  },
};
</script>

<style scoped>

</style>
